import { SignalVerdict } from 'app/modules/reports/types'
import { ReportExportProfileOptions } from '../profile/types'

export enum ReportFormat {
  Misp = 'misp',
  Stix = 'stix',
  Html = 'html',
  Pdf = 'pdf',
  Raw = 'raw',
}

export enum ReportFormatSlow {
  Html = 'html',
  Pdf = 'pdf',
}

export enum ReportFormatState {
  Created = 'created',
  Queued = 'queued',
  In_progress = 'in_progress',
  Failed = 'failed',
  Success = 'success',
}

export type ReportFormatItem = {
  id: string
  flow_id: string
  report_id: string
  file_name: string
  file_sha256: string
  verdict: SignalVerdict
  format: ReportFormatSlow
  state: ReportFormatState
  created_date: string
  started_date: string | null
  finished_date: string | null
  settings: ReportExportProfileOptions
  error_stage?: string | null
}
